import { Link } from 'react-router-dom';
import type { Match } from '@/lib/site';

interface RelatedMatchesProps {
  items: Match[];
  leagueLabel: string;
  leaguePath: string;
}

export default function RelatedMatches({ items, leagueLabel, leaguePath }: RelatedMatchesProps) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
      <div className="flex items-center justify-between gap-2 px-4 py-3 border-b border-background-200">
        <h3 className="font-heading text-sm tracking-wider text-foreground-900 flex items-center gap-2">
          <i className="ri-fire-line text-accent-600" />
          相关推荐
        </h3>
        <Link to={leaguePath} className="text-[11px] text-primary-700 hover:text-primary-900 transition-colors whitespace-nowrap">
          更多 {leagueLabel}
        </Link>
      </div>
      <ul className="divide-y divide-background-200">
        {items.map((item) => (
          <li key={item.id}>
            <Link to={`/detail/${item.id}`} className="block px-4 py-3 hover:bg-background-100 transition-colors">
              <div className="flex items-center justify-between gap-2 mb-1.5">
                <span className="text-[11px] text-foreground-500">{item.leagueLabel}</span>
                <span
                  className={`text-[11px] whitespace-nowrap ${
                    item.status === 'live'
                      ? 'text-accent-600 font-medium'
                      : item.status === 'upcoming'
                        ? 'text-primary-700'
                        : 'text-foreground-400'
                  }`}
                >
                  {item.status === 'live' ? '直播中' : item.status === 'upcoming' ? '即将开始' : '已结束'}
                </span>
              </div>
              <p className="text-sm text-foreground-900 leading-snug">
                {item.home.name}
                <span className="mx-1.5 text-foreground-400 text-xs">vs</span>
                {item.away.name}
              </p>
              <p className="mt-1 text-[11px] text-foreground-500 inline-flex items-center gap-1">
                <i className="ri-time-line" />
                {item.timeLabel}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}